import { render, staticRenderFns } from "./SocieteAtraiter.vue?vue&type=template&id=520f4d5f&scoped=true&"
import script from "./SocieteAtraiter.vue?vue&type=script&lang=js&"
export * from "./SocieteAtraiter.vue?vue&type=script&lang=js&"
import style0 from "./SocieteAtraiter.vue?vue&type=style&index=0&id=520f4d5f&lang=scss&scoped=true&"
import style1 from "./SocieteAtraiter.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520f4d5f",
  null
  
)

export default component.exports